import api from './api';

export const expenseService = {
  getAll: async (params = {}) => {
    const response = await api.get('/expenses', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/expenses/${id}`);
    return response.data;
  },

  create: async (data) => {
    // If data contains a file, use FormData
    if (data.receipt instanceof File) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== undefined && data[key] !== null) {
          if (key === 'receipt') {
            formData.append('receipt', data[key]);
          } else if (key === 'recurring' && typeof data[key] === 'object') {
            // Flatten recurring object
            if (data[key].isRecurring !== undefined) {
              formData.append('recurring[isRecurring]', data[key].isRecurring);
            }
            if (data[key].frequency) {
              formData.append('recurring[frequency]', data[key].frequency);
            }
            if (data[key].nextDueDate) {
              formData.append('recurring[nextDueDate]', data[key].nextDueDate);
            }
          } else {
            formData.append(key, data[key]);
          }
        }
      });
      const response = await api.post('/expenses', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    }

    const response = await api.post('/expenses', data);
    return response.data;
  },

  update: async (id, data) => {
    if (data.receipt instanceof File) {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== undefined && data[key] !== null) {
          if (key === 'receipt') {
            formData.append('receipt', data[key]);
          } else if (key === 'recurring' && typeof data[key] === 'object') {
            // Flatten recurring object
            if (data[key].isRecurring !== undefined) {
              formData.append('recurring[isRecurring]', data[key].isRecurring);
            }
            if (data[key].frequency) {
              formData.append('recurring[frequency]', data[key].frequency);
            }
            if (data[key].nextDueDate) {
              formData.append('recurring[nextDueDate]', data[key].nextDueDate);
            }
          } else {
            formData.append(key, data[key]);
          }
        }
      });
      const response = await api.put(`/expenses/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    }

    const response = await api.put(`/expenses/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/expenses/${id}`);
    return response.data;
  },

  getReports: async (params = {}) => {
    const response = await api.get('/expenses/reports/summary', { params });
    return response.data;
  },
};

export default expenseService;
